var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCalllog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 148,
    height: 143.189,
    viewBox: "0 0 148 143.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    x: 6.747,
    y: 28.513,
    width: 114.677,
    height: 114.676,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#c9cfd7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15575",
    transform: "translate(-108 -232)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 25",
    cx: 3.563,
    cy: 3.563,
    r: 3.563,
    transform: "translate(108 279.5)",
    fill: "#b3c3cd"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 28",
    cx: 3.563,
    cy: 3.563,
    r: 3.563,
    transform: "translate(226.313 325.812)",
    fill: "#b3c3cd"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 26",
    transform: "translate(129.375 241.5)",
    fill: "none",
    stroke: "#bdc1c3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.563,
    cy: 3.563,
    r: 3.563,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.563,
    cy: 3.563,
    r: 3.063
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 27",
    transform: "translate(213.25 232)",
    fill: "none",
    stroke: "#bdc1c3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.563,
    cy: 3.563,
    r: 3.563,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.563,
    cy: 3.563,
    r: 3.063
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9648",
    d: "M129.375 323.081h-2.731v2.731h-.91v-2.731h-2.731v-.91h2.731v-2.731h.91v2.731h2.731z",
    fill: "#d2d7d9"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "add-plus-button"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "add"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9648",
    d: "M174.062 249.456h-2.731v2.731h-.91v-2.731h-2.731v-.91h2.731v-2.731h.91v2.731h2.731z",
    fill: "#d2d7d9"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "add-plus-button"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "add"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9648",
    d: "M256 289.831h-2.731v2.731h-.91v-2.731h-2.731v-.91h2.731v-2.731h.91v2.731H256z",
    fill: "#d2d7d9"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15574"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "24-hours"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 4",
    d: "M211.543 274.314a32.669 32.669 0 00-46.2 0c-.419.418-.824.85-1.219 1.29a11.177 11.177 0 013.086 3.135l6.614 10.068a11.136 11.136 0 01-.58 13.077.357.357 0 00.027.48l10.223 10.221a.35.35 0 00.256.107.342.342 0 00.223-.08 11.148 11.148 0 0113.078-.581l10.068 6.614a11.178 11.178 0 013.135 3.087c.44-.395.871-.8 1.289-1.217a32.67 32.67 0 000-46.2z",
    fill: "#e5e6ec"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "24-hours"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.997 232.003)",
    filter: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13741",
    d: "M94.408 101.965a6.7 6.7 0 00-3.065-5.221l-10.068-6.616a6.812 6.812 0 00-8 .352 4.693 4.693 0 01-6.243-.354l-10.22-10.222a4.692 4.692 0 01-.354-6.242 6.812 6.812 0 00.352-8L50.193 55.59a6.7 6.7 0 00-5.221-3.065 7.252 7.252 0 00-.529-.019 6.683 6.683 0 00-5.079 2.3 22.332 22.332 0 00.914 30.584l21.264 21.264a22.333 22.333 0 0030.586.913 6.7 6.7 0 002.28-5.602zm0 0",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 4",
    d: "M204.854 328.212a11.109 11.109 0 00-1.4-1.684 11.333 11.333 0 00-1.736-1.4l-10.066-6.619a11.148 11.148 0 00-13.078.581.341.341 0 01-.224.08.349.349 0 01-.256-.107l-10.222-10.221a.357.357 0 01-.027-.48 11.136 11.136 0 00.58-13.077l-6.614-10.068a11.32 11.32 0 00-1.4-1.736 11.122 11.122 0 00-1.686-1.399c.433-.483.831-.9 1.216-1.29a32.669 32.669 0 0146.2 0 32.67 32.67 0 010 46.2c-.391.391-.813.789-1.289 1.217zm-19.239-44.329a2.32 2.32 0 00-2.323 2.323v16.264a2.32 2.32 0 002.323 2.323h9.294a2.324 2.324 0 100-4.647h-6.97v-13.94a2.32 2.32 0 00-2.324-2.323z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 5",
    d: "M221.763 284.216v1.813h-7.251v-1.42l4.139-4.9h-4.033v-1.808h7.01v1.42l-4.139 4.9z",
    fill: "#b3c3cd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 7",
    d: "M218.137 268.02v3.068l-12.272.005v-2.4l7-8.29h-6.827v-3.07h11.866v2.4l-7 8.287z",
    fill: "#b3c3cd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCalllog);
export default __webpack_public_path__ + "static/media/empty-calllog.a511c7f978ce39380ce0e1c8e365c48e.svg";
export { ForwardRef as ReactComponent };